import { Button, Modal } from "antd";

export interface OmInUseModalProps {
  isVisible: boolean;
  onClose: () => void;
}

export function OmInUseModal({ isVisible, onClose }: OmInUseModalProps) {
  return (
    <Modal
      className={"clean one"}
      visible={isVisible}
      onCancel={() => onClose()}
    >
      <header>
        <h2>The mobile menu editor is currently in use</h2>
      </header>

      <p>This Mobile Menu may be open on another device.</p>

      <footer>
        <Button size={"large"} className={"primary"} onClick={onClose}>
          Ok
        </Button>
      </footer>
    </Modal>
  );
}
